// extracted by mini-css-extract-plugin
export default {"label":"profileList_label__hv9f1","quantity":"profileList_quantity__Pngce"};